const country = [
    {
      id: "albenia",
      name: "albenia",
      countryCode: "+355",
      flag: "/icons/Albania (AL).svg",
    },
    {
      id: "afghanistan",
      name: "afghanistan",
      countryCode: "+93",
      flag: "/icons/Afghanistan (AF).svg",
    },
    {
      id: "brazil",
      name: "brazil",
      countryCode: "+55",
      flag: "/icons/BR.svg",
    },
    {
      id: "canada",
      name: "canada",
      countryCode: "+1",
      flag: "/icons/CA.svg",
    },
    {
      id: "china",
      name: "china",
      countryCode: "+86",
      flag: "/icons/CN.svg",
    },
    {
      id: "germany",
      name: "germany",
      countryCode: "+49",
      flag: "/icons/EE.svg",
    },
    {
      id: "mexico",
      name: "mexico",
      countryCode: "+52",
      flag: "/icons/MX.svg",
    },
    {
      id: "portugal",
      name: "portugal",
      countryCode: "+351",
      flag: "/icons/PT.svg",
    },
    {
      id: "spain",
      name: "spain",
      countryCode: "+34",
      flag: "/icons/ES.svg",
    },
    {
      id: "unitedKingdom",
      name: "united kingdom",
      countryCode: "+44",
      flag: "/icons/GB.svg",
    },
  ];

  export default country;